<ion-header
  class="ion-no-border"
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'ion-header-modal-tablet'
        : 'ion-header-modal-mobile'
      : 'ion-header-modal-desktop'
  "
>
  <ion-toolbar>
    <ion-buttons
      *ngIf="(platformService?.isTouchExperience$ | async) === false"
      slot="end"
    >
      <ion-button
        data-cy="close-cpr-ngp-price-modal-button"
        class="close-modal-button"
        (click)="closeModal()"
      >
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <h1 data-cy="update-product-price-title">
      {{ 'i18n.orderPage.cprNgpModal.title' | translate }}
    </h1>
  </ion-toolbar>
</ion-header>
<ion-content
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'ion-content-modal-tablet'
        : 'ion-content-modal-mobile'
      : 'ion-content-modal-desktop'
  "
  scroll-y="true"
>
  <div
    class="product-tabs"
    *ngIf="
      !!sellerHandPricingDetail?.description &&
      !!altHandPricingDetail?.description
    "
  >
    <button
      data-cy="update-cpr-ngp-original-product-tab"
      [ngClass]="{ active: currentTab === 1 }"
      (click)="toggleTab(1)"
    >
      {{ 'i18n.handPricing.originalProduct' | translate }}
    </button>
    <button
      data-cy="update-cpr-ngp-substitute-product-tab"
      [ngClass]="{ active: currentTab === 2 }"
      (click)="toggleTab(2)"
    >
      {{ 'i18n.handPricing.subProduct' | translate }}
    </button>
  </div>
  <ion-grid
    [class.desktop]="
      platformService?.platformType === platformService?.platformEnum?.desktop
    "
  >
    <ion-row class="ion-justify-content-around">
      <ion-col size="12" size-sm="6">
        <div class="product-card">
          <div class="product-image">
            <img
              *ngIf="!!prices?.xlargeImageURL"
              data-cy="cpr-ngp-product-xl-image"
              src="{{ prices?.xlargeImageURL }}"
              alt="Product Image"
            />
            <img
              *ngIf="!prices?.xlargeImageURL && !!prices?.thumbnailImageURL"
              data-cy="cpr-ngp-thumbnail-product-image"
              src="{{ prices?.thumbnailImageURL }}"
              alt="Product Image"
            />
            <ion-icon
              name="restaurant"
              *ngIf="!prices?.xlargeImageURL && !prices?.thumbnailImageURL"
              data-cy="cpr-ngp-icon-image"
              class="no-image"
            >
            </ion-icon>
          </div>
          <div class="product-info">
            <span class="brand"> {{ prices?.brand | acronymTitleCase }} </span>
            <span class="product-info-title">{{ prices?.description }}</span>
            <div class="additional-info">
              <span class="product-number">{{ prices?.productNumber }}</span>
              <span class="separator" data-cy="separator-line">|</span>
              <span class="pack-size"> {{ prices?.packSize }}</span>
            </div>

            <span class="original-price"
              ><strong>{{
                'i18n.orderPage.cprNgpModal.originalPrice' | translate
              }}</strong>
              <ng-container *ngIf="prices?.currentPrice">
                <span class="original-price-value">
                  {{ prices?.currentPrice | currency }}
                  {{ prices?.priceUom }}
                </span>
              </ng-container>

              <span
                *ngIf="prices?.currentPrice && prices?.breakable"
                class="border"
                >|</span
              >

              <ng-container
                *ngIf="prices?.breakable"
                data-cy="hand-price-product-each-text"
              >
                {{ prices?.eachPrice | currency }}
                {{ prices?.priceUom === 'LB' ? 'LB' : 'EA' }}
              </ng-container></span
            >
          </div>
        </div>

        <ion-accordion-group
          value="additional-pricing"
          (ionChange)="toggleAdditionalPricingLabel($event)"
        >
          <ion-accordion value="additional-pricing">
            <ion-item slot="header">
              <ion-label>{{
                additionalPricingAccordionLabel | translate
              }}</ion-label>
            </ion-item>
            <div
              slot="content"
              class="additional-pricing-info"
              data-cy="additional-pricing-info"
            >
              <div *ngIf="lastBuy" class="last-buy-section">
                <span class="last-buy-label" data-cy="cpr-modal-last-buy-label"
                  >{{
                    'i18n.productDetail.customPricingRationaleModal.lastPurchase'
                      | translate
                  }}:
                </span>
                <span data-cy="hand-price-last-purchase-value">
                  {{ lastBuy.price }} - {{ lastBuy.invoiceDate }}</span
                >
              </div>
              <div>
                <span
                  class="pricing-label"
                  data-cy="cpr-modal-seller-floor-label"
                  >{{ sellerFloorLabel }}:
                </span>
                <span
                  class="pricing-value"
                  data-cy="hand-price-seller-floor-text"
                  >{{ sellerFloorValue | currency }}
                  {{ 'i18n.orderPage.cs' | translate }}</span
                >
              </div>
              <div>
                <span class="pricing-label" data-cy="cpr-modal-gpp-label"
                  >{{ 'i18n.orderPage.cprNgpModal.gpp' | translate }}:
                </span>
                <span
                  class="pricing-value"
                  data-cy="hand-price-commision-amount-text"
                  >{{
                    prices?.additionalPricingInfo?.grossProfitPercent / 100
                      | percent: '1.2-2'
                  }}</span
                >
              </div>
              <div>
                <span class="pricing-label" data-cy="cpr-modal-gpd-label"
                  >{{ 'i18n.orderPage.cprNgpModal.gpd' | translate }}:
                </span>
                <span
                  class="pricing-value"
                  data-cy="hand-price-commision-amount-text"
                  >{{ prices?.additionalPricingInfo?.grossProfitDollars }}</span
                >
              </div>

              <div>
                <span class="pricing-label" data-cy="hand-price-acs-label"
                  >{{
                    'i18n.handPricing.additionalPricing.ascInd' | translate
                  }}:
                  <span class="pricing-value" data-cy="hand-price-acs-text">{{
                    prices?.additionalPricingInfo?.ascInd
                  }}</span>
                </span>
              </div>

              <div>
                <span
                  class="pricing-label"
                  data-cy="hand-price-acs-charge-label"
                  >{{
                    'i18n.handPricing.additionalPricing.ascCharge' | translate
                  }}:
                  <span
                    class="pricing-value"
                    data-cy="hand-price-acs-charge-text"
                    >{{
                      prices?.additionalPricingInfo?.unitAscRate | currency
                    }}
                    {{ 'i18n.orderPage.cs' | translate }}</span
                  ><span
                    class="pricing-value"
                    *ngIf="prices?.breakable"
                    data-cy="hand-price-acs-charge-rate-text"
                    >{{
                      prices?.additionalPricingInfo?.eachAscRate | currency
                    }}
                    {{ 'i18n.orderPage.ea' | translate }}</span
                  >
                </span>
              </div>
            </div>
          </ion-accordion>
        </ion-accordion-group>
      </ion-col>
      <div class="price-cpr-tabs">
        <button
          [ngClass]="{ active: currentTab === 1 }"
          (click)="togglePriceCPR(1)"
        >
          {{ 'i18n.orderPage.cprNgpModal.setPrice' | translate }}
        </button>
        <button
          [ngClass]="{ active: currentTab === 2 }"
          (click)="togglePriceCPR(2)"
          *ngIf="isCprSetupInd"
        >
          {{ 'i18n.orderPage.cprNgpModal.cprOverride' | translate }}
        </button>
      </div>

      <ion-col size="12" size-sm="6">
        <div class="set-price">
          <h5 class="title">
            {{ 'i18n.orderPage.cprNgpModal.setPrice' | translate }}
          </h5>
          <span class="notice-message">
            {{ 'i18n.orderPage.cprNgpModal.setPriceUpdates' | translate }}
          </span>
          <span class="selectOne-label">
            {{ 'i18n.orderPage.cprNgpModal.selectOne' | translate }}</span
          >

          <ion-list class="ion-content-cpr-desktop">
            <ion-radio-group
              [(ngModel)]="priceRadioSelected"
              (ionChange)="radioPriceChange()"
              class="radio-group"
              data-cy="cpr-price-radio-button"
            >
              <div class="cpr-radio-wrapper">
                <ion-item-divider></ion-item-divider>

                <div
                  class="cpr-radio-row"
                  (click)="selectRadio(RadioOptions.maximum)"
                >
                  <div class="cpr-radio-column1">
                    <ion-label id="change-optimal">
                      {{
                        'i18n.orderPage.cprNgpModal.changeOptimal' | translate
                      }}
                    </ion-label>
                  </div>
                  <div class="cpr-radio-column2">
                    <ion-label>
                      {{ optimalDisplayPrice | formatCurrencyAndDecimalPipe }}
                      {{ this.priceUom }}
                    </ion-label>
                  </div>
                  <div class="cpr-radio-column3">
                    <ion-radio
                      aria-labelledby="change-optimal"
                      mode="md"
                      slot="end"
                      value="{{ priceRadios?.get(RadioOptions.maximum).id }}"
                    ></ion-radio>
                  </div>
                </div>

                <ion-item-divider></ion-item-divider>

                <div
                  class="cpr-radio-row"
                  (click)="selectRadio(RadioOptions.target)"
                >
                  <div class="cpr-radio-column1">
                    <ion-label id="price">
                      {{
                        priceRadios?.get(RadioOptions.target).label | translate
                      }}
                    </ion-label>
                  </div>
                  <div class="cpr-radio-column2">
                    <ion-label>
                      {{ targetDisplayPrice | formatCurrencyAndDecimalPipe }}
                      {{ this.priceUom }}
                    </ion-label>
                  </div>
                  <div class="cpr-radio-column3">
                    <ion-radio
                      aria-labelledby="price"
                      mode="md"
                      slot="end"
                      value="{{ priceRadios?.get(RadioOptions.target).id }}"
                    ></ion-radio>
                  </div>
                </div>

                <ion-item-divider></ion-item-divider>

                <div
                  class="cpr-radio-row"
                  (click)="selectRadio(RadioOptions.custom)"
                >
                  <div class="cpr-radio-column1">
                    <ion-label id="set-custom-price">
                      {{
                        'i18n.orderPage.cprNgpModal.setCustomPrice' | translate
                      }}
                    </ion-label>
                  </div>
                  <div class="cpr-radio-column2">
                    <ion-input
                      aria-labelledby="set-custom-price"
                      [(ngModel)]="priceInputSelected"
                      class="cpr-input-cl"
                      type="number"
                      placeholder="00.00 CS"
                      (keypress)="allowOnlyNumbers($event)"
                    >
                      $
                    </ion-input>
                  </div>
                  <div class="cpr-radio-column3">
                    <ion-radio
                      mode="md"
                      slot="end"
                      value="{{ RadioOptions.custom }}"
                    ></ion-radio>
                  </div>
                </div>

                <ion-item-divider></ion-item-divider>
              </div>
            </ion-radio-group>
            <br />
          </ion-list>
        </div>

        <div
          class="set-cpr"
          *ngIf="isCprSetupInd"
          [ngClass]="
            platformService?.platformType ===
              platformService?.platformEnum?.mobile && tabSwitched === false
              ? 'hide'
              : ''
          "
        >
          <h5 class="title">
            {{ 'i18n.orderPage.cprNgpModal.cprOverride' | translate }}
          </h5>
          <span class="notice-message">
            {{ 'i18n.orderPage.cprNgpModal.submitRequest' | translate }}
          </span>

          <ion-list class="ion-content-cpr-desktop">
            <ion-radio-group
              [allowEmptySelection]="true"
              (ionChange)="selectMakeCpr()"
            >
              <div class="cpr-radio-wrapper">
                <ion-item-divider></ion-item-divider>
                <div class="cpr-radio-row">
                  <div class="cpr-radio-column1 make-cpr-section">
                    <ion-label>
                      {{ 'i18n.orderPage.cprNgpModal.makeCpr' | translate }}
                    </ion-label>
                  </div>
                  <div class="cpr-radio-column3">
                    <ion-radio
                      mode="md"
                      slot="end"
                      value="{{ RadioOptions.makeCpr }}"
                    ></ion-radio>
                  </div>
                </div>

                <ion-item-divider></ion-item-divider>
              </div>
            </ion-radio-group>
          </ion-list>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
<ion-footer class="ion-footer-modal">
  <ion-toolbar>
    <ion-buttons class="cpr-footer-buttons">
      <ion-button
        id="cancel-modal-btn"
        [ngClass]="
          platformService?.platformType !==
          platformService?.platformEnum?.mobile
            ? 'usf-outline-green-dsktp-tblt-modal-button'
            : 'usf-outline-green-button'
        "
        data-cy="cancel-modal-btn"
        (click)="closeModal()"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>

      <ion-button
        class="usf-fill-green-dsktp-tblt-modal-button"
        id="update-modal-btn"
        [ngClass]="
          platformService?.platformType !==
          platformService?.platformEnum?.mobile
            ? 'usf-fill-green-dsktp-tblt-modal-button'
            : 'usf-fill-green-button'
        "
        data-cy="update-modal-btn"
        (click)="updatePrice()"
      >
        {{ 'i18n.common.update' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
